import * as React from 'react';

import styled from '@emotion/styled';

const Svg = styled.svg`
  width: 18px;
  height: 18px;
  margin-right: 0.5rem;
`;

const TreeCBCheckedIcon = () => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg">
      <defs>
        <clipPath id="a">
          <path fill="none" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
      <g data-name="checked box" clip-path="url(#a)" stroke-width="2">
        <g data-name="Checkbox full" fill="#fff" stroke="#bdcad2">
          <rect width="18" height="18" rx="3" stroke="none" />
          <rect x="1" y="1" width="16" height="16" rx="2" fill="none" />
        </g>
        <path
          data-name="Path 5"
          d="M4.876 9.579l2.633 2.633 5.453-5.453"
          fill="none"
          stroke="#7ab800"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </Svg>
  );
};

export default TreeCBCheckedIcon;
